export const FRONT = 0
export const REAR = 1

export const SPEED_RATING = 'Speed Rating MPH'
export const THREAD_LIFE_WARRANTY = 'Manufacturer Mileage Warranty'
